module.exports = __webpack_public_path__ + "static/media/btn_revenue.120a1910.png";